import { ScrollArea } from "@/core/components/ui/scroll-area";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { IAiScriptExplanationChatThread } from "@/payroll/ai-script/types";
import { ChatThreadListItem } from "./chat-thread-list-item";

interface ChatThreadListProps {
  threads: IAiScriptExplanationChatThread[];
  getIsThreadRunning: (threadId: string) => boolean;
  onOpenThread: (threadId: string) => void;
}

export const ChatThreadList = ({
  threads,
  getIsThreadRunning,
  onOpenThread,
}: ChatThreadListProps) => (
  <ScrollArea className="min-h-0 flex-1">
    <Stack gap="sm" className="px-5 py-4" align="stretch">
      {threads.length === 0 && (
        <Typography variant="bodyW3" textColor="secondary">
          No chats yet for this pay period.
        </Typography>
      )}
      {threads.map((thread) => (
        <ChatThreadListItem
          key={thread.id}
          thread={thread}
          isRunning={getIsThreadRunning(thread.id)}
          onOpen={onOpenThread}
        />
      ))}
    </Stack>
  </ScrollArea>
);
